import { Screen } from '~/screens/users';

export const IndexUser: React.FC = () => {
  return <Screen />;
};
